<template>
  <div class="exam-paper container">
    <div class="header">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>资源管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/examQuestions/list` }">题目管理</el-breadcrumb-item>
        <el-breadcrumb-item>题目详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="tips">
            <p class="label">
              <i class="el-icon-warning-outline"></i>
              试卷编辑为实时保存，建议编辑时先关闭相关引用的上线状态，避免影响用户操作
            </p>
          </div>
        </div>
        <div class="right">
          <el-button
            type="primary"
            @click="handleToPreview"
          >预览</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="exam-wrap">
        <div
          class="exam-item"
          v-for="(item, $index) in pages[pageIndex]"
          :key="item.id"
        >
          <Single
            v-if="item.answer_type === 0"
            :title="`${computeIndex($index)+1} 单选题`"
            :content="item"
            @save="handleExamSave($event, $index)"
          >
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <el-button
                type="text"
                @click="handleExamRemove(computeIndex($index))"
                disabled
              >删除</el-button>
            </div>
          </Single>
          <Multiple
            v-if="item.answer_type === 1"
            :title="`${computeIndex($index)+1} 多选题`"
            :content="item"
            @save="handleExamSave($event, $index)"
          >
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <el-button
                type="text"
                @click="handleExamRemove(computeIndex($index))"
                disabled
              >删除</el-button>
            </div>
          </Multiple>
          <Judge
            v-if="item.answer_type === 3"
            :title="`${computeIndex($index)+1} 判断题`"
            :content="item"
            @save="handleExamSave($event, $index)"
          >
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <el-button
                type="text"
                @click="handleExamRemove(computeIndex($index))"
                disabled
              >删除</el-button>
            </div>
          </Judge>
          <Qa
            v-if="[4,5,6,7,9,10].includes(item.answer_type)"
            :title="`${computeIndex($index)+1} 自测题`"
            :content="item"
            @save="handleExamSave($event, $index)"
          >
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <el-button
                type="text"
                @click="handleExamRemove(computeIndex($index))"
                disabled
              >删除</el-button>
            </div>
          </Qa>
          <Material
            v-if="item.answer_type === 8"
            :title="`${computeIndex($index)+1} 材料题`"
            :content="item"
            @save="handleExamSave($event, $index)"
            @update="updateData"
          >
            <div style="display: flex;">
              <div v-if="$index != 0">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'up')"
                >上移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <div v-if="$index != itemList.length-1">
                <el-button
                  type="text"
                  @click="handleExamSortChange(computeIndex($index), 'down')"
                >下移</el-button>
                <el-divider
                  class="divider"
                  direction="vertical"
                ></el-divider>
              </div>
              <el-button
                type="text"
                @click="handleExamRemove(computeIndex($index))"
                disabled
              >删除</el-button>
            </div>
          </Material>
          <div class="category-wrap">
            <el-tag
              :key="tag"
              v-for="tag in item.category_ids?item.category_ids.split(','):[]"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              style="margin: 0px 8px;"
            >
              {{tag}}
            </el-tag>
            <el-autocomplete
              class="inline-input"
              v-if="inputVisible"
              v-model="inputValue"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="handleSelect"
              @keyup.enter.native="handleInputConfirm(item)"
              @blur="handleInputConfirm(item)"
            ></el-autocomplete>
            <!--       <el-select
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
              <el-option
                v-for="item in $store.state.examcategorylist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <el-button
              v-else
              class="button-new-tag"
              size="mini"
              @click="showInput"
            >添加分类</el-button>
          </div>
        </div>
        <!--     <div
          class="exam-add"
          v-if="itemList.length<1"
        >
          <p>+添加题目</p>
          <div class="exam-buttons">
            <el-button
              type="primary"
              @click="handleExamItemAdd(0)"
            >单选题</el-button>
            <el-button
              type="primary"
              @click="handleExamItemAdd(1)"
            >多选题</el-button>
            <el-button
              type="primary"
              @click="handleExamItemAdd(3)"
            >判断题</el-button>
            <el-button
              type="primary"
              @click="handleExamItemAdd(4)"
            >问答题</el-button>
            <el-button
              type="primary"
              @click="handleExamItemAdd(8)"
            >材料题</el-button>
            <el-button
              type="primary"
              icon="el-icon-link"
              @click="handleExamItemCopy"
            >题目引用</el-button>
          </div>
        </div> -->
      </div>
    </div>
    <div class="pager">
      <div
        :class="{'page': true,'active': pageIndex === $index}"
        v-for="(item, $index) in pages"
        :key="$index"
        @click="handlePageChange($index)"
      >{{$index+1}}</div>
    </div>
    <PaperItemChoose
      :visible="paperChooseVisible"
      @submit="handlePaperChoose"
      @close="paperChooseVisible=false"
    ></PaperItemChoose>
  </div>
</template>

<script>
import Single from '@/components/examquestion/Single'
import Multiple from '@/components/examquestion/Multiple'
import Judge from '@/components/examquestion/Judge'
import Qa from '@/components/examquestion/Qa'
import Material from '@/components/examquestion/Material'
import PaperItemChoose from "@/components/dialog/paper/PaperItemChoose";
import {
  examPaperOne,
  examPaperItemList,
  examPaperItemCreate,
  examPaperItemsUpdate,
  examPaperItemDestroy,
  examPaperItemLink,
  examItemOne,
  examItemUpdate,
  examItemcategorycreate
} from '@/api/exam'

export default {
  components: {
    Single,
    Multiple,
    Judge,
    Qa,
    Material,
    PaperItemChoose
  },
  data() {
    return {
      paper: {},
      itemList: [],
      pageIndex: 0,
      pages: [[]],
      paperChooseVisible: false,
      inputVisible: false,
      inputValue: '',
      dynamicTags: [],
    }
  },
  created() {
    this.fetchExamItemOne()

  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    formateQuery() {
      /*  this.itemList = [JSON.parse(this.$route.query.obj)] */

      this.itemList.forEach(item => {
        if (item.options) {
          item.options.forEach(v => {
            v.true_option = v.true_option === 1 ? true : false
          })
        }
        if (item.children) {
          item.children.forEach(subItem => {
            if (subItem.options) {
              subItem.options.forEach(v => {
                v.true_option = v.true_option === 1 ? true : false
              })
            }
          })
        }
      })

      // 分组切割：避免性能问题
      this.itemListChunks()
    },
    updateData() {
      this.fetchExamItemOne()
    },
    fetchExamItemOne() {
      examItemOne({ id: this.$route.query.id }).then((res) => {
        /*    this.itemList.reverse().reverse()
           this.itemList = [res]
           console.log(this.itemList); */
        this.$set(this.itemList, 0, res)


        this.formateQuery()

      });
    },
    // 滚动到页面顶部
    scrollToTop() {
      document.querySelector('#content').scrollTop = 0
    },
    // 题目保存
    handleExamSave(event, index) {
      this.itemList[index].content = event
      if (event.itemList) {
        this.itemListChunks()
      }
    },
    // 题目排序
    handleExamSortChange(index, type) {

    },
    // 题目删除
    handleExamRemove(index) {
      // 二次确认撤销
      this.$confirm(
        `删除操作无法找回，请谨慎操作。`,
        "提示",
        {
          confirmButtonText: '确定删除',
          type: "warning"
        }
      ).then(() => {
        examPaperItemDestroy({ id: this.itemList[index].id }).then((res) => {
          this.itemList.splice(index, 1);
          this.itemListChunks();
        });
      }).catch(() => { });
    },
    // 题目添加
    handleExamItemAdd(type) {
      let itemValue = {
        paper_id: this.paper.id,
        answer_type: type,
        sort: this.itemList.length
      }
      if (type === 8) {
        itemValue.material = 1
      }
      examPaperItemCreate(itemValue).then(res => {
        if (res.options) {
          res.options.forEach(v => {
            v.true_option = v.true_option === 1 ? true : false
          })
        }
        this.itemList.push(res)
        this.itemListChunks()
      })
    },
    // 题目批量添加
    handleExamItemCopy() {
      this.paperChooseVisible = true
    },
    // 题目批量添加提交
    handlePaperChoose(val) {
      if (val && val.selections && val.selections.length) {
        const items = val.selections.map(v => ({ id: v.item_id, answer_type: v.answer_type }))
        examPaperItemLink({ items, paper_id: this.paper.id }).then(res => {
          this.fetchExamPaperItemList()
        })
      }
    },
    // 预览
    handleToPreview() {
      // if (this.paper) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/exam/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/exam/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   }
      // }
    },
    // 分页
    handlePageChange(index) {
      this.pageIndex = index
      this.scrollToTop()
    },
    // 索引值计算
    computeIndex(index) {
      const pages = this.pages
      const temps = pages.slice(0, this.pageIndex)
      const length = ([].concat(...temps)).length
      return length + index
    },
    // 题库列表分割
    itemListChunks() {
      // 20题左右一组
      const totalItems = this.itemList
      const pages = [[]]
      totalItems.forEach(item => {
        let last = pages[pages.length - 1]
        let length = last.length
        // 材料题
        if (item.material) {
          length += (item.children ? item.children.length : 1)
        } else {
          length += 1
        }
        last.push(item)
        if (length >= 20) {
          pages.push([])
        }
      })
      /*    console.log(this.itemList);
         console.log(pages); */
      this.$set(this.pages, 0, pages[0])
      console.log(this.pages);
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      /*     this.$nextTick(() => {
            this.$refs['saveTagInput'].focus()
          }); */
    },

    handleInputConfirm(item) {
      let inputValue = this.inputValue;
      if (inputValue) {
        examItemcategorycreate({ name: inputValue }).then((res) => {
          this.$store.dispatch('getExamCategoryList')
          if (res) {

            let arr = item.category_ids ? item.category_ids.split(',') : []
            arr.push(inputValue);
            examItemUpdate({ id: item.id, category_ids: arr.join(',') || "" }).then(res => {
              // 数据向外层传递
              this.updateData()
            }).catch(error => {
              this.$message.error('更新异常')
              console.log('error: ', error)
            })
          }
        });

      }
      this.inputVisible = false;
      this.inputValue = '';

    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.examcategorylist;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    }
  }
}
</script>

<style scoped lang="less">
.exam-paper {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title-wrap {
      display: flex;
      justify-content: space-between;
    }
    .input-box {
      display: flex;
      align-items: center;
      flex: 1;

      .el-input {
        width: 320px;
      }
    }
    .exam-wrap {
    }
    .exam-item {
      & + .exam-item {
        margin-top: 20px;
      }
    }
    .exam-add {
      position: relative;
      color: #303133;
      background-color: #fff;
      border: 1px dashed #0091ff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      overflow: hidden;
      padding: 20px;
      margin-top: 20px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .exam-buttons {
        margin-top: 10px;

        /deep/ .el-button {
          padding: 10px 30px;
          margin: 0 20px;
        }
      }
    }
  }
  .pager {
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);

    .page {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      color: #666;
      background: rgb(198, 226, 255);
      border-radius: 50%;
      cursor: pointer;

      & + .page {
        margin-top: 5px;
      }

      &.active {
        color: #fff;
        background: #409eff;
        cursor: default;

        &:hover {
          color: #fff;
        }
      }
      &:hover {
        color: #409eff;
      }
    }
  }
  .category-wrap {
    margin-top: 16px;
    padding: 16px 0px;
    box-sizing: border-box;
  }
}
</style>
